import React, { useRef, useCallback } from "react";
import CameraStream from "../../Streaming/Video/CameraStream";
import "./StreamCard.css";

const StreamCard = React.memo(({ stream, onRemove, isPlaying }) => {
  const cameraRef = useRef(null);

  const handleSnapshot = useCallback(() => {
    const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
    const filename = `snapshot-${stream.vehicleName}-${stream.channel}-${timestamp}`;
    cameraRef.current?.takeScreenshot(filename);
  }, [stream.vehicleName, stream.channel]);

  return (
    <div className="stream-card">
      <div className="stream-card-header">
        <div className="stream-card-title">
          Live Stream - {stream.vehicleName} ({stream.channel})
        </div>
        <button
          className="stream-card-snapshot"
          onClick={handleSnapshot}
          type="button"
          title="Take Snapshot"
        >
          📷
        </button>
        <button className="stream-card-close" onClick={onRemove} type="button">
          ×
        </button>
      </div>
      <div className="stream-card-content">
        {stream.isLoading ? (
          <div style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100%",
            color: "white",
            fontSize: "14px"
          }}>
            Starting stream...
          </div>
        ) : (
          <CameraStream
            ref={cameraRef}
            url={stream.streamUrl}
            webrtcUrl={stream.webrtcUrl}
            hlsUrl={stream.hlsUrl}
            isPlaying={isPlaying}
            mode="streaming"
          />
        )}
      </div>
    </div>
  );
});

export default StreamCard;
